import { createAsyncThunk } from '@reduxjs/toolkit';
import { refreshTokenAPI } from '../services/auth'; 
import { logout, refreshToken as refreshTokenAction } from './authSlice'; 

// Define the thunk for refreshing the token
export const refreshTokenThunk = createAsyncThunk(
  'auth/refreshToken',
  async (refreshToken: string, { dispatch }) => {
    try {
      const response = await refreshTokenAPI(refreshToken); 
      if (response) {
        dispatch(refreshTokenAction(response)); 
      }
    } catch (error) {
      console.error('Failed to refresh token:', error);
      dispatch(logout()); 
      throw error; 
    }
  }
);